// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Message_wrapper__FJhio","body":"Message_body__2MoOJ","text":"Message_text__V-QcV"};